import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './read-all-area.styl'

export default class ReadAllArea extends Component {
  static propTypes = {
    children: PropTypes.any
  }

  //
  // componentDidMount() {
  //   document.documentElement.addEventListener('scroll', this.handleScroll)
  // }
  //
  // componentWillUnmount() {
  //   document.documentElement.removeEventListener('scroll', this.handleScroll)
  // }

  // handleScroll = () => {
  //
  // }

  render() {
    return (
      <div className={styles.wrap}>
        {this.props.children}
      </div>
    )
  }
}
